/**
 * OrbDocGettingStartedIntroductionSLOrbDocGettingStartedIntroductionSLPage
 *
 * Page component for OrbDocGettingStartedIntroductionSLOrbDocGettingStartedIntroductionSLPage
 * Path: /sl/docs/getting-started/introduction
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocGettingStartedIntroductionSLDocScreenView as __OrbDocGettingStartedIntroductionSLDocScreenView } from '@/components/traits/OrbDocGettingStartedIntroductionSLDocScreenView';
import { OrbDocGettingStartedIntroductionSLDocAnalyticsView as __OrbDocGettingStartedIntroductionSLDocAnalyticsView } from '@/components/traits/OrbDocGettingStartedIntroductionSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocGettingStartedIntroductionSLOrbDocGettingStartedIntroductionSLPageProps {
  // Add any page-level props here
}

export function OrbDocGettingStartedIntroductionSLOrbDocGettingStartedIntroductionSLPage(_props: OrbDocGettingStartedIntroductionSLOrbDocGettingStartedIntroductionSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Uvod v Orb","description":"Orb je jezik za programsko opremo, ki mora upoštevati pravila. Ti navedeš stanja in dogodke, prevajalnik zgradi aplikacijo ali pove, zakaj je ne more.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/getting-started/introduction"},{"locale":"ar","path":"/ar/docs/getting-started/introduction"},{"locale":"sl","path":"/sl/docs/getting-started/introduction"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocGettingStartedIntroductionSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocGettingStartedIntroductionSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocGettingStartedIntroductionSLOrbDocGettingStartedIntroductionSLPage;
